export default __webpack_public_path__ + "assets/imgs/preto_caramelo_4.65621e8b.png";